// Ready-made dropdown filters for ListPage.
import { api } from '../../../services/api/apiClient';
import { toOptions } from '../../../utils/labels';
import type { LabelMap, StatusMap } from '../../../types/common';
import type { ListFilter } from '../../../types/table';

export { toOptions };

const remote = (path: string, extra?: Record<string, any>) => (search: string): Promise<any[]> => api.get(path, { search, limit: 20, ...extra }).then((r) => r.data);

export const dateFilter = (label = 'Date'): ListFilter => ({ type: 'date', key: 'date', label });

export const customerFilter: ListFilter = {
  key: 'customerId',
  label: 'Customer',
  icon: 'user',
  fetcher: remote('/customers'),
  getDescription: (c) => c.phone,
};

export const vendorFilter: ListFilter = {
  key: 'vendorId',
  label: 'Supplier',
  icon: 'truck',
  fetcher: remote('/vendors'),
  getDescription: (v) => v.phone,
};

export const workerFilter: ListFilter = {
  key: 'assignedTo',
  label: 'Worker',
  icon: 'users',
  fetcher: remote('/users', { role: 'worker' }),
  getDescription: (u) => u.phone,
};

export const activeFilter: ListFilter = {
  key: 'isActive',
  label: 'Status',
  icon: 'checkCircle',
  options: [
    { value: 'true', label: 'Active' },
    { value: 'false', label: 'Inactive' },
  ],
};

export const optionsFilter = (key: string, label: string, map: StatusMap | LabelMap, icon?: string): ListFilter => ({ key, label, icon, options: toOptions(map) });

/** Opens WhatsApp with a message to a 10 digit Indian mobile. */
export function whatsapp(phone: string | null | undefined, text: string) {
  const digits = (phone ?? '').replace(/\D/g, '').slice(-10);
  window.open(`https://wa.me/${digits.length === 10 ? `91${digits}` : ''}?text=${encodeURIComponent(text)}`, '_blank', 'noopener');
}
